export default "__VITE_ASSET__MSLsiZxB__"